module.exports = __webpack_public_path__ + "open-sans-semibold.33b67be977acf26d6696.woff";


//////////////////
// WEBPACK FOOTER
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/assets/fonts/google/open-sans-semibold.woff
// module id = /6cm
// module chunks = 1